module.exports = __webpack_public_path__ + "img/Karon.2fa7b539.webp";